import Chip from '@mui/material/Chip'
import LockIcon from '@mui/icons-material/Lock'
import PublicIcon from '@mui/icons-material/Public'

interface EndpointBadgeProps {
  type: 'public' | 'apikey'
}

export default function EndpointBadge({ type }: EndpointBadgeProps) {
  if (type === 'public') {
    return (
      <Chip
        icon={<PublicIcon />}
        label="Public"
        size="small"
        color="success"
        variant="outlined"
        sx={{ ml: 1, fontWeight: 500 }}
      />
    )
  }
  return (
    <Chip
      icon={<LockIcon />}
      label="API Key Required"
      size="small"
      color="primary"
      variant="outlined"
      sx={{ ml: 1, fontWeight: 500 }}
    />
  )
}
